import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconPeople = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M19.733 9.412c-4.704.362-8.865 3.52-10.536 7.996-1.232 3.299-.938 7.176.774 10.232.6 1.072 1.14 1.776 2.092 2.73 1.239 1.242 2.404 2.035 3.944 2.686.689.29 2.188.736 2.479.736.32 0 .076.07-.573.166-3.256.479-6.454 1.894-9.081 4.018-.69.558-1.916 1.765-2.51 2.472-2.78 3.307-4.393 7.563-4.426 11.68-.008.91 0 .978.16 1.312.588 1.239 2.197 1.572 3.169.657.458-.43.663-.964.663-1.725 0-1.274.292-3 .733-4.34a15.1 15.1 0 0 1 2.232-4.32c.58-.782 2.205-2.407 2.987-2.987 3.94-2.924 8.967-3.734 13.6-2.192a14.83 14.83 0 0 1 10.046 12.179c.054.413.099.972.1 1.243.002 1.033.166 1.598.596 2.05.289.306.658.503 1.083.58.863.157 1.7-.247 2.127-1.026.169-.307.191-.415.213-1.032.03-.807-.073-2.08-.25-3.119-.965-5.642-4.52-10.607-9.563-13.356-2.053-1.118-4.227-1.827-6.656-2.167l-.32-.045.571-.12c2.29-.48 4.776-1.889 6.344-3.595 3.514-3.825 4.33-9.244 2.082-13.837-1.944-3.974-5.747-6.54-10.195-6.879-.923-.07-.929-.07-1.885.003m.082 4.028c-2.867.361-5.308 2.088-6.511 4.605-.578 1.209-.83 2.317-.83 3.65 0 1.436.253 2.481.922 3.801 1.142 2.254 3.386 3.913 5.9 4.36.756.135 2.13.135 2.88.001 2.688-.48 4.91-2.185 6.083-4.662 1.5-3.172.794-7.008-1.741-9.458a7.6 7.6 0 0 0-2.102-1.469c-.777-.38-1.574-.646-2.293-.764-.577-.094-1.8-.129-2.308-.064m25.209 3.502c-4.465.613-7.986 3.863-8.93 8.242-.176.816-.244 2.677-.128 3.486.457 3.19 2.197 5.863 4.913 7.547.478.297 1.443.764 1.794.869.215.064.13.13-.286.223-.482.107-1.457.432-1.766.589-.402.204-.72.54-.907.958-.158.352-.174.449-.149.913q.065 1.198 1.112 1.706c.533.26.998.247 1.979-.054 1.366-.419 2.423-.59 3.646-.588 1.87 0 3.525.395 5.25 1.251q3.519 1.746 5.284 5.244c.797 1.58 1.274 3.464 1.276 5.044 0 .581.103.968.363 1.364.378.576.94.87 1.663.87.798 0 1.454-.423 1.807-1.166.158-.334.166-.4.156-1.28-.046-3.86-1.712-7.774-4.519-10.614-1.886-1.909-4.163-3.29-6.669-4.047-.458-.138-.882-.251-.941-.251-.186 0-.188-.112-.004-.158.097-.023.435-.166.752-.316 3.21-1.522 5.375-4.424 5.927-7.942.103-.659.103-2.412 0-3.072-.53-3.389-2.657-6.286-5.75-7.833-.846-.423-1.997-.777-3.057-.94-.53-.082-2.34-.11-2.816-.045m.587 3.992c-.75.08-1.404.278-2.187.666-3.467 1.718-4.603 6.197-2.377 9.373a6.36 6.36 0 0 0 5.545 2.735c1.684-.073 3.076-.683 4.258-1.866a6.3 6.3 0 0 0 1.87-4.201c.17-3.428-2.325-6.335-5.757-6.71a9 9 0 0 0-.736-.059c-.063.005-.34.033-.616.062" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconPeople.displayName = 'IconPeople';